<template>
    <div data-app class="p-1">
        <notifications v-if="isPublic"></notifications>
        <v-card class="mx-auto hidden-card">
            <maximize-and-minimize></maximize-and-minimize>
            <v-card-title>
                <h4 class="title pt-1">Pesquisar</h4>
            </v-card-title>
            <div class="card-content">
                <div>
                    <v-row>
                        <v-col v-if="!isPublic" cols="12" md="4">
                            <v-autocomplete
                                v-model="branch"
                                :items="branches"
                                item-text="name"
                                :search-input.sync="searchBranches"
                                cache-items
                                class="mx-4"
                                flat
                                hide-no-data
                                hide-details
                                label="Filial"
                                return-object
                                :disabled="disableBranchSearch"
                                clearable
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                label="Árvore de sortimento"
                                name="node"
                                id="node"
                                value=""
                                style="cursor: pointer"
                                v-model="selectedHistoryFilterNodeName"
                                @click.native="treeModalOpen(true)"
                                readonly
                                :disabled="disableNodeFilter"
                            />
                        </v-col>
                    </v-row>
                    <div class="add-btn">
                        <Button
                            label="Filtrar"
                            @click.native="filterByTree"
                            color="#3F51B5"
                            :disabled="disableFilterButton"
                        />
                    </div>
                </div>
            </div>
        </v-card>

        <v-card class="mx-auto" v-show="itemsQuantity">
            <v-card-title>
                <h4 class="title pt-1">Quantidade de itens</h4>
            </v-card-title>
            <div class="card-content">
                <div v-show="!filtering">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                label="ID"
                                name="id"
                                id="id"
                                readonly
                                :value="filteredNodeExternalId"
                                :disabled="generating"
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                label="Sortimento"
                                name="assortment"
                                id="assortment"
                                readonly
                                :value="filteredNodeName"
                                :disabled="generating"
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="quantityByAmplitude"
                                label="Quantidade"
                                name="quantity"
                                id="quantity"
                                type="number"
                                min="0"
                                :value="quantityByAmplitude"
                                :disabled="generating"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div class="add-btn m-0">
                                <Button
                                    label="Gerar ranking"
                                    color="#3F51B5"
                                    @click.native="generateRanking"
                                    :disabled="generating"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div v-show="filtering" class="text-center">
                    <v-row>
                        <v-col>
                            <img
                                src="loader.svg"
                                style="width: 100px; height: 100px"
                            />
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-card>

        <div v-show="items.length > 0 || isLoading" style="position: relative;">
            <h4 class="pb-2">Lista de Produtos à serem solicitados</h4>
            <v-card v-show="isLoading" class="text-center">
                <img src="loader.svg" style="width: 100px; height: 100px" />
            </v-card>
            <div v-show="!isLoading">
                <div class="active-parameters">
                    <LegendInfo
                        class="legend"
                        bgColor="#98FF98"
                        color="#3c653c"
                        description="Aprovado Automaticamente"
                    />
                    <LegendInfo
                        class="legend"
                        bgColor="#8585FF"
                        color="#5656a4"
                        description="Reposição Dinâmica Ativa"
                    />
                    <v-checkbox
                        color="#8585FF"
                        class="checkbox"
                        label="Parâmetros ativos"
                        v-model="selectedProducts"
                    />
                </div>
                <div class="card-row">
                    <div
                        class="card-column"
                        v-for="(item, index) in items"
                        :key="index"
                        v-show="selectedProducts ? item.isSelected : true"
                    >
                        <flip-card
                            :title="item.title"
                            :referenceNumber="item.referenceNumber"
                            :data="item.data"
                            :img="item.img"
                            :hide-checkbox="false"
                            :editableItems="['parameters']"
                            :hiddenItems="[
                                'solicitation',
                                'dynamicReplacement'
                            ]"
                            :cardStyle="item.style.card"
                            :loading="item.loading"
                            @flip="updateProduct(index)"
                        >
                            <template slot="extra-title">
                                <span>{{ item.rankingPosition }}</span>
                            </template>
                            <template slot="img-footer">
                                <v-container class="p-0 m-0">
                                    <v-row>
                                        <v-col>
                                            <img
                                                :src="
                                                    `/img/chip_${item.curve.toLowerCase()}.svg`
                                                "
                                                :alt="`Classe: ${item.curve}`"
                                                :title="`Classe: ${item.curve}`"
                                            />
                                        </v-col>
                                        <v-col cols="auto">
                                            <v-icon
                                                v-if="item.isGuaranteedStock"
                                                title="Garantido"
                                                style="color:var(--red-400)"
                                            >
                                                mdi-lock
                                            </v-icon>
                                            <v-icon
                                                v-if="item.isFavorite"
                                                title="Favorito"
                                                style="color:var(--yellow-400)"
                                            >
                                                mdi-star
                                            </v-icon>
                                            <span
                                                v-if="item.isNew"
                                                title="Novo"
                                            >
                                                <img
                                                    src="/img/new-product.png"
                                                    alt="Novo Produto"
                                                    title="Novo Produto"
                                                />
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template slot="item" slot-scope="{ prop }">
                                <div
                                    v-if="
                                        prop.title ===
                                            restockingTitles.DC_OVERVIEW.name
                                    "
                                >
                                    <table class="card-table">
                                        <thead class="center">
                                            <tr>
                                                <th></th>
                                                <th>Estoque</th>
                                                <th>Saldo à Receber</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(propName,
                                                propNameIndex) in Array.from(
                                                    new Set(
                                                        prop.props.map(
                                                            value => {
                                                                return value.name
                                                            }
                                                        )
                                                    )
                                                )"
                                                :key="propNameIndex"
                                                :style="
                                                    prop.props[propNameIndex]
                                                        .style
                                                "
                                            >
                                                <td>
                                                    {{ propName }}
                                                </td>
                                                <td
                                                    v-for="(prop,
                                                    propIndex) in prop.props.filter(
                                                        value =>
                                                            value.name ==
                                                            propName
                                                    )"
                                                    :key="propIndex"
                                                    class="center"
                                                >
                                                    <v-skeleton-loader
                                                        v-show="item.loading"
                                                        type="text"
                                                        max-width="80"
                                                        class="mt-1"
                                                    />
                                                    <span
                                                        v-show="!item.loading"
                                                        >{{ prop.value }}</span
                                                    >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                            <template slot="prop" slot-scope="{ prop }">
                                <v-text-field
                                    v-if="
                                        prop.name ===
                                            restockingTitles.SOLICITATION
                                                .subTitles.SHOWCASE_ITEMS
                                    "
                                    class="card-text-field"
                                    v-model="item[prop.key]"
                                    type="number"
                                    min="0"
                                    hide-details="auto"
                                    @change="changeQuantity(index)"
                                />
                                <v-text-field
                                    v-else-if="
                                        prop.name ===
                                            restockingTitles.SOLICITATION
                                                .subTitles.STACK_ITEMS
                                    "
                                    class="card-text-field"
                                    v-model="item[prop.key]"
                                    type="number"
                                    min="0"
                                    hide-details="auto"
                                    @change="changeQuantity(index)"
                                />
                                <v-text-field
                                    v-else-if="
                                        prop.name ===
                                            restockingTitles.SOLICITATION
                                                .subTitles.COVERAGE
                                    "
                                    class="card-text-field"
                                    v-model="item[prop.key]"
                                    type="number"
                                    min="0"
                                    hide-details="auto"
                                    @change="changeQuantity(index)"
                                />
                                <v-text-field
                                    v-else-if="
                                        prop.name ===
                                            restockingTitles.SOLICITATION
                                                .subTitles.STOCK_MAX
                                    "
                                    class="card-text-field"
                                    v-model="item[prop.key]"
                                    type="number"
                                    min="0"
                                    hide-details="auto"
                                />
                                <span v-else>{{ prop.value }}</span>
                            </template>
                            <template slot="checkbox">
                                <v-checkbox
                                    :color="item.style.checkboxColor"
                                    class="checkbox"
                                    v-model="item.isSelected"
                                    :disabled="disableCheckBox(item)"
                                />
                            </template>
                        </flip-card>
                    </div>
                </div>
            </div>
            <div id="save-btn">
                <Button
                    v-show="items.length > 0"
                    @click.native="openSaveModal"
                    label="Salvar Pedido"
                    color="#3F51B5"
                />
            </div>
            <div class="footer-info">
                <p class="card-category">
                    Mostrando
                    {{ items.length }}
                    itens de um total de {{ items.length }}.
                </p>
                <p class="card-category">
                    Selecionado {{ selectedItems.length }} de um total de
                    {{ maxSelect }}
                </p>
            </div>
        </div>

        <!-- Modal to select tree node -->
        <modal v-if="treeModal" @close="treeModalOpen(false)" width="500px">
            <template slot="header">
                <h4 class="modal-title">Item da árvore de sortimento</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="treeModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <v-draggable-treeview
                    v-model="treeData"
                    :editable="false"
                    :openCallback="readTreeChild"
                    :clickCallback="selectTreeChild"
                    :disableDrag="true"
                ></v-draggable-treeview>
            </template>
            <template slot="footer"></template>
        </modal>
        <modal v-show="openModal" text-align="center">
            <template slot="header">
                <h1>Confirmar a criação do pedido</h1>
            </template>
            <template slot="body">
                <div v-show="creating" class="text-center">
                    <img src="loader.svg" style="width: 100px; height: 100px" />
                </div>
                <div v-show="!creating">
                    <p>
                        <span>Filial: </span
                        >{{ branch && branch.name ? branch.name : '' }}
                    </p>
                    <p><span>Tipo de pedido: </span>Reposição Dinâmica</p>
                    <ul>
                        <li v-for="(item, index) in selectedItems" :key="index">
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
            </template>
            <template slot="footer">
                <div class="confirm-btns">
                    <Button
                        class="left"
                        @click.native="openModal = false"
                        label="Não"
                        color="#f55a4e"
                        :disabled="creating"
                    />
                    <Button
                        class="right"
                        @click.native="create"
                        label="Sim"
                        color="#3F51B5"
                        :disabled="creating"
                    />
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState, mapMutations } from 'vuex'
import { FlipCard, VuetifyDraggableTreeview } from '@/components'
import LegendInfo from '@/components/Legend/LegendInfo'
import MaximizeAndMinimize from '@/components/Maximize/MaximizeAndMinimize.vue'
import Button from '@/components/Button/Button.vue'
import { Modal } from '@/components'
import { Solicitation as Model } from '@/models/solicitation.model'
import {
    solicitationTypes as Types,
    status as Status
} from '@/services/constants/index.js'

export default {
    name: 'restocking-management-page',
    props: {
        items: {
            type: Array,
            required: true
        },
        itemsBackups: {
            type: Array,
            required: false
        },
        _create: {
            type: Function,
            required: true
        }
    },
    async created() {
        this.isPublic = this.$route.meta.public ?? false
        this.cardModel = Model.restockingCard()
    },
    data() {
        return {
            creating: false,
            isPublic: false,
            quantityByAmplitude: null,
            openModal: false,
            product: null,
            productList: [],
            searchBranches: null,
            cardModel: {},
            isCreate: true,
            loading: false,
            filtering: false,
            hasFiltered: false,
            generating: false,
            filterActionDisabled: false,
            selectedProducts: false,
            selectedHistoryFilterNodeName: null,
            selectedHistoryFilterNodeExternalId: null,
            filteredNodeName: null,
            filteredNodeExternalId: null,
            treeModal: false,
            itemsQuantity: false,
            amplitude: [],
            typeUpdateAmplitudeParameter:
                Types.TYPE_UPDATE_AMPLITUDE_PARAMETER_PK,
            typeRemoveProduct: Types.TYPE_REMOVE_PRODUCT_PK,
            typeUpdateAssortmentParameter:
                Types.TYPE_UPDATE_ASSORTMENT_PARAMETER_PK,
            typeAddProduct: Types.TYPE_ADD_PRODUCT_MANAGER_PK,
            restockingTitles: Model.cardTitles().RESTOCKING_MANAGEMENT,
            indexesToChange: []
        }
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me,
            stockState: state => state['movements'].stockState,
            branchParameters: state => state['branchparameter'].page.results,
            branchParameter: state => state['branchparameter'].branchParameter,
            branches: state => state['branches'].page.results,
            branch: state => state['branches'].branch,
            products: state => state['products'].page.results,
            treeAncestors: state => state['nodes'].ancestors,
            restockingState: state => state['restocking'].amplitudePage.results,
            amplitudeState: state => state['restocking'].amplitude,
            ranking: state => state['ranking'].data
        }),

        treeData() {
            return [{ name: 'Todos os itens', id: null }]
        },

        selectedItems() {
            return _.filter(this.items, object => object.isSelected)
        },

        maxSelect() {
            return this.productList[0]?.max_select ?? 0
        },

        disableBranchSearch() {
            return (
                this.items.length > 0 ||
                this.hasFiltered ||
                this.filtering ||
                this.generating
            )
        },

        disableNodeFilter() {
            return this.filtering || this.generating
        },

        disableFilterButton() {
            return (
                this.filtering || this.filterActionDisabled || this.generating
            )
        },

        isLoading() {
            return this.loading || this.generating
        },

        branch: {
            get() {
                return this.$store.state['branches'].branch
            },
            set(value) {
                this.readBranchSuccess(value)
            }
        }
    },
    methods: {
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),

        ...mapActions('movements', {
            readStockState: 'read'
        }),

        ...mapActions('branches', {
            readBranches: 'read'
        }),

        ...mapActions('branchparameter', {
            readBranchParameters: 'read',
            createBranchParameter: 'create'
        }),

        ...mapActions('products', {
            readProducts: 'read'
        }),

        ...mapActions('restocking', {
            readAmplitude: 'readAmplitude',
            createAmplitude: 'createAmplitude'
        }),

        ...mapActions('ranking', {
            readRanking: 'readRanking'
        }),

        ...mapMutations('branches', {
            readBranchSuccess: 'readBranchSuccess',
            mapBranchesNames: 'mapNames'
        }),

        ...mapMutations('products', {
            mapProductsNames: 'mapNames'
        }),

        treeModalOpen(state) {
            this.treeModal = state
        },

        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },

        async selectTreeChild(item) {
            this.nameTreeNode(item.id)
            this.treeModal = false
        },

        async nameTreeNode(idNode) {
            this.filterActionDisabled = true
            await this.readTreeAncestors({ id: idNode })
            if (idNode && this.treeAncestors.length > 0) {
                this.selectedHistoryFilterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.selectedHistoryFilterNodeName += ' > '
                    this.selectedHistoryFilterNodeName += ancestor.name
                })
                this.selectedHistoryFilterNode = this.treeAncestors[
                    this.treeAncestors.length - 1
                ]
                let lastAncestor = this.treeAncestors.slice(-1)
                let ancestorObj = lastAncestor.pop()
                this.selectedHistoryFilterNodeExternalId =
                    ancestorObj.external_id
            } else {
                this.selectedHistoryFilterNode = new Node()
                this.selectedHistoryFilterNodeName = 'Todos os itens'
            }
            this.filterActionDisabled = false
        },

        async loadAmplitude() {
            this.filtering = true
            await this.readAmplitude({
                branch: this.branch.id,
                node: this.selectedHistoryFilterNode.id
            })
            this.filtering = false
            this.amplitude = this.restockingState
        },
        async loadRestockingData() {
            await this.loadAmplitude()
            if (this.restockingState && this.restockingState.length === 0) {
                await this.createAmplitude({
                    node: this.selectedHistoryFilterNode.id,
                    branch: this.branch.id,
                    quantity: 0
                })
                this.amplitude = [this.amplitudeState.data]
            }
            this.hasFiltered = true
        },

        getCard() {
            const card = {
                ...this.cardModel,
                branch: this.branch,
                product: this.product.id,
                referenceNumber: this.product.reference_number,
                title: this.product.name,
                rankingPosition: this.product.rankingPosition + '#',
                img: this.product.image_url,
                curve: this.product.curve,
                loading: false,
                branchparameter: this.product.branchParameter,
                showcase_items: this.product.showcaseItems,
                coverage: this.product.coverage,
                stack_items: this.product.stackItems,
                stock_max: this.product.stockMax,
                isSelected: this.product.isSelected,
                isStockReserve: this.product.isStockReserve,
                autoApproved: this.product.autoApproved,
                cost: this.product.cost ?? 0,
                price: this.product.price ?? 0,
                channel: this.branch.channel,
                style: this.getCardStyle(this.product),
                isNew:
                    this.branchParameters.length > 0
                        ? this.branchParameters[0].is_new
                        : '',
                isGuaranteedStock:
                    this.branchParameters.length > 0
                        ? this.branchParameters[0].guaranteed_stock
                        : '',
                isFavorite:
                    this.branchParameters.length > 0
                        ? this.branchParameters[0].is_favorite
                        : '',
                data: this.cardModel.data
            }
            return card
        },

        async getExtraCardValues(index) {
            const card = this.items[index]
            const args = {
                products: [card.product],
                branch: this.branch.id,
                showcase_items: parseInt(card.showcase_items),
                stack_items: parseInt(card.stack_items),
                coverage: parseInt(card.coverage)
            }
            await this.readStockState(args)
            const { parent_stock_state, ...rest } = this.stockState[0]
            const branchStockState = rest
            const dCStockState = parent_stock_state

            return card.data.map(item => {
                return {
                    ...item,
                    props: item.props.map(prop => {
                        const value =
                            (item.title ==
                                this.restockingTitles.BRANCH_OVERVIEW.name ||
                                item.title ==
                                    this.restockingTitles.DYNAMIC_MINIMUM
                                        .name) &&
                            branchStockState
                                ? branchStockState[prop.key]
                                : item.title ==
                                      this.restockingTitles.DC_OVERVIEW.name &&
                                  dCStockState
                                ? dCStockState[prop.key]
                                : ''
                        return {
                            ...prop,
                            value
                        }
                    })
                }
            })
        },

        notifyMessage(message, type = 'danger') {
            this.$emit('notify', { message, type })
        },

        async filterByTree() {
            if (this.branch && this.selectedHistoryFilterNode) {
                this.itemsQuantity = true
                try {
                    this.emitItems([])
                    this.filteredNodeName = this.selectedHistoryFilterNodeName
                    this.filteredNodeExternalId = this.selectedHistoryFilterNodeExternalId
                    this.loadRestockingData()
                } catch (e) {
                    this.notifyMessage(
                        'Desculpe, houve um erro ao filtrar. Tente novamente mais tarde.'
                    )
                }
            } else {
                this.notifyMessage(
                    'É necessário selecionar uma filial e uma árvore de sortimento'
                )
            }
        },

        async updateAmplitudeParameter() {
            const solicitation = {
                branch: this.amplitude[0].branch,
                items: [
                    {
                        amplitude: this.amplitude[0].id,
                        branch: this.amplitude[0].branch,
                        node: this.amplitude[0].node.id,
                        quantity: parseInt(this.quantityByAmplitude),
                        colors: [],
                        nodes: [],
                        solicitation_type: this.typeUpdateAmplitudeParameter
                    }
                ]
            }
            await this.createSolicitation(solicitation, false)
        },

        async generateRanking() {
            this.generating = true
            try {
                this.emitItems([])
                if (
                    this.quantityByAmplitude &&
                    this.quantityByAmplitude !== this.amplitude[0].quantity
                ) {
                    await this.updateAmplitudeParameter()
                }
                await this.readRanking({ amplitude: this.amplitude[0].id })

                if (this.ranking.length > 0) {
                    this.productList = this.ranking
                    this.productList.forEach((item, index) => {
                        this.product = {
                            ...item.product,
                            name:
                                item.product.external_id +
                                ' - ' +
                                item.product.name,
                            isSelected: item.is_selected,
                            isStockReserve: item.is_stock_reserve,
                            rankingPosition: item.ranking_position,
                            autoApproved: item.auto_approved,
                            branchParameter: item.branchparameter,
                            stackItems: item.stack_items,
                            showcaseItems: item.showcase_items,
                            coverage: item.coverage,
                            stockMax: item.stock_max,
                            curve: item.curve
                        }
                        const card = this.getCard()
                        this.items.push(card)
                        this.indexesToChange.push(index)
                    })
                    this.emitItemsBackups(_.cloneDeep(this.items))
                } else {
                    this.notifyMessage('Não existe ranking para essa amplitude')
                }
            } catch (e) {
                console.error(e)
                this.notifyMessage(
                    'Desculpe, houve um erro ao gerar o ranking. Tente novamente mais tarde.'
                )
            }
            this.generating = false
        },
        emitItems(items) {
            this.$emit('setItems', items)
        },
        emitItemsBackups(items) {
            this.$emit('setItemsBackups', items)
        },
        async createSolicitation(solicitation, reset = true) {
            if (solicitation.items.length > 0) {
                await this._create(solicitation, reset)
            } else {
                this.notifyMessage('Pedido não realizado, pois não há mudanças')
            }
        },
        async updateProduct(index) {
            if (this.indexesToChange.includes(index)) {
                this.items[index].loading = true
                let card = await this.getExtraCardValues(index)

                card.map(item => {
                    item.props.map(prop => {
                        let indexKey = this.getIndexesAndKey(
                            index,
                            item.title,
                            prop.key
                        )
                        this.items[index].data[indexKey.dataIndex].props.splice(
                            indexKey.propIndex,
                            1,
                            {
                                ...this.items[index].data[indexKey.dataIndex]
                                    .props[indexKey.propIndex],
                                value: prop.value
                            }
                        )
                    })
                })
                this.items[index].loading = false
                this.indexesToChange = this.indexesToChange.filter(
                    i => i !== index
                )
            }
        },

        filterBranches() {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(async () => {
                await this.readBranches({
                    q: this.searchBranches
                })
                this.mapBranchesNames()
            }, 500)
        },

        getCardStyle(item) {
            return item.isSelected
                ? {
                      card: { background: '#8585FF' },
                      checkboxColor: '#fff'
                  }
                : item.autoApproved
                ? { card: { background: '#98FF98' }, checkboxColor: '#8585FF' }
                : ''
        },

        openSaveModal() {
            var validationFails = false
            var errorMessage = null

            if (this.selectedItems.length === 0) {
                validationFails = true
                errorMessage = 'É necessário selecionar pelo menos um produto.'
            } else if (this.selectedItems.length > this.maxSelect) {
                validationFails = true
                errorMessage = `É necessário desselecionar pelo menos ${this
                    .selectedItems.length - this.maxSelect} produto(s).`
            } else {
                validationFails = this.selectedItems.some(
                    item =>
                        item.showcase_items == null ||
                        item.stack_items == null ||
                        item.coverage == null ||
                        item.stock_max == null
                )

                errorMessage =
                    'É necessário informar os parâmetros para os produtos selecionados'
            }
            if (validationFails) {
                this.notifyMessage(errorMessage)
            } else {
                this.openModal = true
            }
        },

        itemsToAddInAssortment(preSelectedItems) {
            return _.filter(this.selectedItems, item => {
                return !preSelectedItems.some(
                    preItem =>
                        item.product === preItem.product &&
                        preItem.isSelected === item.isSelected
                )
            }).map(item => {
                return {
                    product: item.product,
                    solicitation_type: this.typeAddProduct
                }
            })
        },

        itemsToRemoveInAssortment(preSelectedItems) {
            return _.filter(preSelectedItems, preItem => {
                return !this.selectedItems.some(
                    item =>
                        item.product === preItem.product &&
                        preItem.isSelected === item.isSelected
                )
            }).map(item => {
                return {
                    product: item.product,
                    solicitation_type: this.typeRemoveProduct
                }
            })
        },

        async getOrCreateBranchParameter(item) {
            let branchParameter = _.find(
                this.branchParameters,
                parameter => parameter.product.id === item.product
            )
            if (!branchParameter) {
                await this.createBranchParameter({
                    branch: item.branch,
                    product: item.product,
                    cost: item.cost,
                    price: item.price,
                    channel: item.channel,
                    showcase_items: 0,
                    stack_items: 0,
                    coverage: 0,
                    stock_max: 0
                })
                branchParameter = this.branchParameter
            }
            return branchParameter
        },

        async itemsToUpdateParameters() {
            const items = []
            await Promise.all(
                this.selectedItems.map(async item => {
                    const product = _.find(
                        this.itemsBackups,
                        object => object.product === item.product
                    )
                    if (
                        item.coverage !== product.coverage ||
                        item.showcase_items !== product.showcase_items ||
                        item.stack_items !== product.stack_items ||
                        item.stock_max !== product.stock_max
                    ) {
                        await this.readBranchParameters({
                            products: [item.product],
                            branch_id: this.branch.id
                        })
                        const branchParameter = await this.getOrCreateBranchParameter(
                            item
                        )
                        items.push({
                            solicitation_type: this
                                .typeUpdateAssortmentParameter,
                            branchparameter: branchParameter.id,
                            coverage: parseInt(item.coverage),
                            showcase_items: parseInt(item.showcase_items),
                            stack_items: parseInt(item.stack_items),
                            stock_max: parseInt(item.stock_max)
                        })
                    }
                })
            )
            return items
        },

        async create() {
            this.creating = true
            try {
                const items = []

                const preSelectedItems = _.filter(
                    this.itemsBackups,
                    object => object.isSelected
                )
                const addedItems = this.itemsToAddInAssortment(preSelectedItems)
                const removedItems = this.itemsToRemoveInAssortment(
                    preSelectedItems
                )
                const updatedParametersItems = await this.itemsToUpdateParameters()

                items.push(
                    ...addedItems,
                    ...removedItems,
                    ...updatedParametersItems
                )
                const solicitation = {
                    branch: this.branch.id,
                    items
                }
                await this.createSolicitation(solicitation)
            } catch (e) {
                this.notifyMessage(
                    'Desculpe, houve um erro ao realizar o pedido.'
                )
            }
            this.openModal = false
            this.creating = false
        },

        getIndexesAndKey(index, title, key, valueKey = null) {
            const dataIndex = this.items[index].data.findIndex(
                d => d.title == title
            )
            const props = this.items[index].data[dataIndex].props
            const keyToFind = valueKey ?? key

            return {
                dataIndex,
                propIndex: props.findIndex(item => item.key == keyToFind),
                key
            }
        },

        changeQuantity(index) {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(() => {
                if (!this.indexesToChange.includes(index)) {
                    this.indexesToChange.push(index)
                }
                if (!this.selectedItems.includes(this.items[index])) {
                    if (this.selectedItems.length < this.maxSelect) {
                        this.items[index].isSelected = true
                    } else {
                        this.notifyMessage(
                            `É necessário desselecionar pelo menos ${this
                                .selectedItems.length -
                                this.maxSelect +
                                1} produto(s).`
                        )
                    }
                }
            }, 1000)
        },

        disableCheckBox(item) {
            return (
                item.isStockReserve ||
                (this.selectedItems.length >= this.maxSelect &&
                    this.selectedItems.findIndex(
                        i => i.product === item.product
                    ) === -1)
            )
        }
    },
    watch: {
        searchBranches: {
            handler: function(val) {
                val && val !== this.branch && this.filterBranches()
            }
        },
        amplitude: {
            handler: function(val) {
                let quantity = val[0]?.quantity
                this.quantityByAmplitude = quantity === 0 ? null : quantity
            },
            deep: true
        }
    },
    components: {
        MaximizeAndMinimize,
        'v-draggable-treeview': VuetifyDraggableTreeview,
        FlipCard,
        Modal,
        Button,
        LegendInfo
    }
}
</script>

<style scoped>
.add-btn {
    margin: 15px 0px;
}
.card-content {
    padding: 20px;
}
.card-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
}
.card-row::after {
    content: '';
    flex: auto;
}
.card-column {
    max-width: 400px;
    height: 730px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 400px;
    margin-bottom: 100px;
}
.card-text-field,
.card-select-field,
.card-textarea-field {
    margin-top: -25px;
    margin-left: 10px;
    margin-bottom: 10px;
}
.card-text-field {
    width: 100px;
}
.card-select-field,
.card-textarea-field {
    max-width: 220px;
}
.v-card,
li {
    margin-bottom: 30px;
}
ul {
    list-style: none;
}
#save-btn {
    position: fixed;
    bottom: 0;
    padding: 5px 15px;
}
.modal-header > h1 {
    font-size: 18px;
}
.modal-header > h1,
.modal-body > p > span {
    font-weight: bold;
}
.confirm-btns {
    display: inline-block;
    width: 100%;
}
.confirm-btns > .btn {
    width: 50%;
    width: 49%;
}
.left {
    float: left;
}
.right {
    float: right;
}
.card-table {
    width: 100%;
}
.card-table .center {
    text-align: center;
}
.card-table td,
.card-text p {
    padding: 4px 0px;
    margin: 0;
}
@media (min-width: 990px) {
    .active-parameters {
        font-size: 13px;
        position: absolute;
        top: -20px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .legend {
        float: left;
    }
}
@media (min-width: 601px) {
    .add-btn {
        float: right;
    }
    #save-btn {
        right: 2%;
    }
}
@media (max-width: 600px) {
    .v-card {
        text-align: center;
    }
    #save-btn {
        width: 100%;
        left: 0;
    }
    .add-btn > .btn,
    #save-btn > .btn {
        width: 100%;
    }
    .active-parameters {
        position: relative;
    }
    .modal-title {
        font-size: 16px;
    }
}
</style>
